<template >
  <div class="container-h5" >
    <div class="buttondiv">
      <img @click="downLoadApp('apple')"  class="imgbutton" src="../assets/inviteapple.png">
      <br>
      <img   @click="downLoadApp('android')"  class="imgbutton" style="margin-top: 20px" src="../assets/inviteandroid.png">
    </div>
  </div>

</template>
<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'invite',
  props: {
    msg: String
  },
  methods:{
    downLoadApp(type){
      if(type == 'apple'){
        window.open('https://apps.apple.com/jp/app/hotchat-private-strangerchat/id1625816962?l=en')
      }else{
        window.open('https://play.google.com/store/apps/details?id=com.gzxkwl.hochat')
      }
    }
  }
}

</script>
<style scoped>
@import "../assets/style/style.css";
</style>
<style>
.container-h5 {
  width: 100%;
  height: 100%;
  background-image: url("../assets/invitebg.png");
  background-size: 100% 100%;
}
.buttondiv{
  top: 70%;
  width: 100%;
  position: absolute;
  text-align: center;
}
.imgbutton{
  width: 58% ;
}
</style>
